export default "/images/vendor/jquery-ui/themes/base/ui-icons_777620_256x240.png?8003dc8ce47dd77bd0187ce80345024b";